/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_SigningInputs */

const en_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing bonus`)
};

const de_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterzeichnungsbonus`)
};

const fr_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prime d'embauche`)
};

const es_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bono de incorporación`)
};

const it_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus di ingresso`)
};

const nl_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekenbonus`)
};

const pl_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premia na start`)
};

const fi_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allekirjoitusbonus`)
};

const da_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underskriftsbonus`)
};

const sv_salary_negotiate_other_signing = /** @type {(inputs: Salary_Negotiate_Other_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signeringsbonus`)
};

/**
* | output |
* | --- |
* | "Signing bonus" |
*
* @param {Salary_Negotiate_Other_SigningInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_signing = /** @type {((inputs?: Salary_Negotiate_Other_SigningInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_SigningInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_signing(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_signing(inputs)
	if (locale === "es") return es_salary_negotiate_other_signing(inputs)
	if (locale === "it") return it_salary_negotiate_other_signing(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_signing(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_signing(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_signing(inputs)
	if (locale === "da") return da_salary_negotiate_other_signing(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_signing(inputs)
	return en_salary_negotiate_other_signing(inputs)
});